import React from 'react';
import "./custom.css";

export function Printbreak(){
    return(
        <div class="pagebreak"></div>
    )
}

export default Printbreak;